import { put, all, takeLatest, select } from 'redux-saga/effects';
import actions, { apiActions } from './actions';
import { authTokenSelector } from '../session';

export function* getLicensees(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiActions.dataGov.licensees.get(authToken, action.payload.query));
}

function* dataGovSagas() {
  yield all([
    takeLatest(actions.dataGov.licensees.get().type, getLicensees)
  ]);
}

export default dataGovSagas;



// WEBPACK FOOTER //
// ./src/state/modules/data-gov/sagas.js